import { Link, Navigate, useParams } from "react-router-dom";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { JOURNAL } from "../data/content";
import { MaskedLines, Reveal } from "../components/Motion";
import { CtaBand } from "../components/Cta";

export default function JournalArticle() {
  const { slug } = useParams();
  const index = JOURNAL.findIndex((a) => a.slug === slug);
  if (index === -1) return <Navigate to="/journal" replace />;
  const article = JOURNAL[index];
  const next = JOURNAL[(index + 1) % JOURNAL.length];

  return (
    <>
      <section className="page-hero" data-testid="article-hero">
        <div className="ph-image" style={{ backgroundImage: `url(${article.image})` }} />
        <div className="ph-overlay" />
        <div className="ph-content">
          <p className="crumb">
            <Link to="/journal" data-testid="article-crumb-journal">Journal</Link> <span>/</span> {article.tag}
          </p>
          <h1>
            <MaskedLines lines={[article.title]} delay={0.2} />
          </h1>
          <div className="ph-tags">
            <span className="tag gold">{article.tag}</span>
            <span className="tag">{article.date}</span>
            <span className="tag">{article.readTime}</span>
          </div>
        </div>
      </section>

      <article className="article-body section-pad" data-testid="article-body">
        {article.body.map((paragraph, i) => (
          <Reveal key={i}>
            <p>{paragraph}</p>
          </Reveal>
        ))}
        <p className="article-byline">Written by the Oasis studio</p>
      </article>

      <CtaBand testid="article-cta-band" />

      <Link to={`/journal/${next.slug}`} className="next-link" data-testid="article-next-link">
        <span>
          Next essay <ArrowRight size={12} style={{ verticalAlign: "-1px" }} />
        </span>
        <h3>{next.title}</h3>
      </Link>
      <div className="back-row">
        <Link to="/journal" className="text-link" data-testid="article-back-link">
          <ArrowLeft size={15} /> All essays
        </Link>
      </div>
    </>
  );
}
